import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  Theme,
  Typography,
  styled,
} from '@material-ui/core';

import { ListItem, ListItemWrapper, SvgIcon } from 'src/modules/shared/components';
import { FontAwesomeSpriteIcon } from 'src/modules/shared/components/FontAwesomeLocal';

export const AnswersContentWrapper = styled('div')<Theme>(({ theme }) => ({
  padding: '2rem 1.5rem',
  borderBottom: theme.config.defaultBorder(theme.palette.grey['100']),
}));

export const ExerciseLabel = styled('div')<Theme>(({ theme }) => ({
  padding: theme.spacing(2, 1.5, 1, 1.5),
  color: theme.palette.grey['500'],
}));

export const BackIcon = styled(SvgIcon)({
  position: 'absolute',
  top: '50%',
  left: 0,
  transform: 'translateY(-50%)',
});

export const BackToGroupButton = styled('span')<Theme>(({ theme }) => ({
  display: 'flex',
  position: 'relative',
  fontSize: theme.typography.h4.fontSize,
  fontStyle: 'italic',
  textDecoration: 'underline',
  marginBottom: theme.spacing(2),
  cursor: 'pointer',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const AnswersLabel = styled('div')<Theme>(({ theme }) => ({
  color: theme.palette.grey['700'],
  width: '30rem',
  textAlign: 'left',
}));

export const AnswersName = styled('span')<Theme>(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: 600,
}));

export const AttemptsWrapper = styled('div')<Theme>(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

export const StyledQuestionTitle = styled('div')<Theme>(({ theme }) => ({
  flex: '0 0 100%',
  marginBottom: theme.spacing(1),
  '& p': {
    margin: 0,
  },
}));

export const StyledAccordion = styled(Accordion)({
  boxShadow: 'none',
  '&.Mui-expanded': {
    margin: 0,
  },
});

export const StyledDivider = styled(Divider)<Theme>(({ theme }) => ({
  flex: '0 0 100%',
  margin: theme.spacing(2, 0),
}));

export const StyledAccordionSummary = styled(AccordionSummary)({
  padding: 0,
  '&.Mui-expanded': {
    minHeight: '4.8rem',
  },
  '& .MuiAccordionSummary-content': {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '0 !important',
    '&.Mui-expanded': {
      margin: 0,
    },
  },
});

export const StyledAccordionDetails = styled(AccordionDetails)({
  flexWrap: 'wrap',
});

export const AccordionIcon = styled(FontAwesomeSpriteIcon)({
  position: 'absolute',
  left: 0,
});

export const Label = styled('span')<Theme>(({ theme }) => ({
  color: theme.palette.grey['700'],
}));

export const Score = styled('span')<Theme>(({ theme }) => ({
  '&.warning': {
    color: theme.palette.error.main,
  },
}));

export const AverageTitle = styled(Typography)<Theme>(({ theme }) => ({
  paddingLeft: theme.spacing(1),
  flexBasis: '50%',
}));

export const StyledListItem = styled(ListItem)<Theme>(({ theme }) => ({
  borderRadius: theme.config.defaultBorderRadius,
}));

export const DataGrid = styled('div')({
  position: 'relative',
});

export const StyledListItemWrapper = styled(ListItemWrapper)<Theme>(({ theme }) => ({
  cursor: 'pointer',
}));

export const UserDetails = styled('div')<Theme>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  width: '30rem',
  paddingLeft: theme.spacing(1),
  flexBasis: '50%',
}));

export const UserName = styled('div')<Theme>(({ theme }) => ({
  marginLeft: theme.spacing(1),
  fontSize: theme.typography.body1.fontSize,
}));

export const Row = styled('div')<Theme>(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  '&.header': {
    padding: theme.spacing(1, 2),
  },
}));

export const Col = styled('div')<Theme>(({ theme }) => ({
  flexBasis: '25%',
  textAlign: 'center',
  '&.average': {
    fontWeight: 700,
  },
  '&.warning': {
    color: theme.palette.error.main,
  },
}));

export const AverageRow = styled(Row)<Theme>(({ theme }) => ({
  borderTop: theme.config.defaultBorder(theme.palette.grey['100']),
  padding: theme.spacing(1, 0),
}));

export const StyledSummary = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  margin: '0 !important',
  minHeight: '4.8rem',
  alignItems: 'center',
});

export const NoAnswerMessage = styled('span')<Theme>(({ theme }) => ({
  display: 'block',
  marginBottom: theme.spacing(2)
}));